import { render, staticRenderFns } from "./apuppt.vue?vue&type=template&id=b0b2d998&scoped=true"
import script from "./apuppt.vue?vue&type=script&lang=js"
export * from "./apuppt.vue?vue&type=script&lang=js"
import style0 from "./apuppt.vue?vue&type=style&index=0&id=b0b2d998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b2d998",
  null
  
)

export default component.exports